// extracted by mini-css-extract-plugin
export var brand = "_21-9";
export var compact = "_21-6";
export var extraSmall = "_21-7";
export var icon = "_21-0";
export var large = "_21-4";
export var light = "_21-1";
export var medium = "_21-5";
export var outline = "_21-b";
export var primaryDark = "_21-a";
export var primaryLight = "_21-8";
export var primaryModern = "_21-c";
export var success = "_21-2";
export var successSolid = "_21-3";